import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { customStylesSelect } from "../Class/Class_Etc"

//Add By KAI : 10 AUG 2023
// การใช้งาน props
// API_URL                = url API  โดย นำมาจากค่า configData.API_URL

// pro_id(string)         = "" : ให้ระบุ Project ID ที่จะดึงข้อมูล Deparment 

// selectismulti          = true , false เพื่อบอกว่า เลือกได้ ครั้งละหลายรายการหรือไม่

// SelectTextDefault      = ค่าแรกสุดที่เป็น value -1 จะให้ชื่อว่าอะไร
//                        = โดย selectismulti = true เท่านั้น ถึงนำไปใช้
//                        = ถ้า  selectismulti = false เราจะไม่นำไปใช้

// resetSelect            = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก Reset

// onChangevalue          = ส่ง function เข้ามา เพื่อตอน เลือกค่าใน select จะได้ return event กลับไปยัง function ข้างนอก
//                        = เพื่อให้ function ข้างนอกนั้น เอาไป set ค่าใช้งานอีกที
//                        = โดยจะเป็น function ที่ รับ parameter 1 ตัวเท่านั้น

// iscloseMenuOnSelect    = true , false เพื่อบอกว่า  เมื่อมีการเลือก ข้อมูล select แล้ว ตัวกล่อง select จะถูกปิด หรือ เปิดค้างไว้  
//                        = true   เมื่อเลือกก็จะปิด select เหมาะสำหรับ selectismulti = false  
//                        = false  เมื่อเลือกก็จะเปิด select ค้างไว้ เหมาะสำหรับ selectismulti = true

// SelectFirstTime        = เพื่อใช้ในการแสดงผลของ index แรก (0) ส่ง function เข้ามา และต้อง imprement function นี้

function Select_Department(props) {
  const {
    API_URL,
    pro_id,
    selectismulti,
    SelectTextDefault,
    resetSelect,
    onChangevalue,
    iscloseMenuOnSelect,
    isSelectFistTime,
    SelectFirstTime,
  } = props;

  const [isFirst, setIsFirst] = useState(true);
  const [listDepartment, setListDepartment] = useState([]);
  const [selectDepartment, setSelectDepartment] = useState([]);
  const animatedComponents = makeAnimated();

  useEffect(() => {
    if (isFirst) {
      BindDDL_Department();
      setIsFirst(false);
    }
    // eslint-disable-next-line
  }, [isFirst]);

  useEffect(() => {
    if (resetSelect) {
      setSelectDepartment([]);
      onChangevalue(null);
    }
    // eslint-disable-next-line
  }, [resetSelect]);

  async function BindDDL_Department(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;

      raw = JSON.stringify({
        pro_id: pro_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        API_URL + "ProjectOrgDepartment_Getlist",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          const arr = [];

          if (selectismulti === false && SelectTextDefault !== "") {
            arr.push({
              value: "-1",
              label: SelectTextDefault,
            });
          }

          json.data.map((en) => {
            return arr.push({
              value: en.pro_dept_id,
              label: en.dept_name,
            });
          });

          setListDepartment(arr);
          setSelectDepartment(arr[0]);
          if (isSelectFistTime === true){
           
            SelectFirstTime(arr[0].value);
           
          }
          
        } else {
          setListDepartment([]);
        }
        if (_callback != null) {
          _callback();
        }
      }
      else {
        setListDepartment([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListDepartment([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  function onChange_select(e) {
    setSelectDepartment(e);
    onChangevalue(e);
  }

  return (
    <>
      <Select
        closeMenuOnSelect={iscloseMenuOnSelect}
        components={animatedComponents}
        placeholder={SelectTextDefault}
        isMulti={selectismulti}
        options={listDepartment}
        value={selectDepartment}
        isClearable={true}
        menuPortalTarget={document.body}
        onChange={(e) => onChange_select(e)}
         //styles={{
          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        //}}
        styles={customStylesSelect}
      />
    </>
  );
}

export default Select_Department;
